module.exports = ".pwdChangeWrapper {\n  background: #F5F5F5;\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n@media (max-device-width: 824px) and (orientation: landscape) {\n  .pwdChangeWrapper {\n    height: 100% !important;\n  }\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/isolated-pwd-change/isolated-pwd-change.component.css
// module id = ./src/app/Screens/isolated-pwd-change/isolated-pwd-change.component.css
// module chunks = main